import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseService } from '../../../base.service';

@Injectable({
  providedIn: 'root'
})
export class CreatelicenseService {

  constructor( public BaseService:BaseService,private http: HttpClient) { }

  private getHeaders() {
    const token = localStorage.getItem('token');
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
  }

  getTaskList(ProductId:any) {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/MS/ProductFeatures/GetByProductID/'+ProductId, {
      headers,
    });
  }

  getPlansByProductId(productId: number) {
    const headers = this.getHeaders();
    return this.http.get(
      `${this.BaseService.BASEURL}/api/MS/Plan/GetByProductId`,
      {
        headers,
        params: {
          Id: productId.toString(),
        },
      }
    );
  }
  
  InsertLicense(licenseData:any)
  {
    const headers = this.getHeaders();

    return this.http.post(this.BaseService.BASEURL + '/api/License/Create',licenseData ,{
      headers,
    });
  }

  PurchaseWithCard(purchaseData: any) {
    const headers = this.getHeaders();
    return this.http.post(
      this.BaseService.BASEURL + '/api/License/PurchaseWithCard',
      purchaseData,
      { headers }
    );
  }
}
